import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Mote, MoteTranslation, MoteType } from '../../models';

@Component({
    selector: 'mini-tour',
    templateUrl: './mini-tour.component.html',
    styleUrls: ['./mini-tour.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MiniTourComponent implements OnInit {

    @Input() tour: Mote = null;
    @Input() translations: MoteTranslation[] = null;
    @Input() loadingNavigation: boolean = false;
 
    public imageLoaded: boolean = false;

    // Expose to view
    public MoteType = MoteType;

    constructor() { }

    ngOnInit(): void {
    }

}
